import { MENU_VIEW_MODES } from '@aytm/app/stats/page/question-views/mn/components/menu-section/chart/lib/constants'

// only the heatmap-by-clicks view reads the raw levels/contours; every other
// view reads the by-polygons (per section) variants
export const getHeatmapData = (answer, menuViewMode) => {
  const menutestHeatmap = answer?.menutestHeatmap
  if (!menutestHeatmap) return null

  const byClicks = MENU_VIEW_MODES.HEATMAP === menuViewMode

  return {
    levels: byClicks ? menutestHeatmap.levels : menutestHeatmap.levels_by_polygons,
    contours: byClicks ? menutestHeatmap.contours : menutestHeatmap.contours_by_polygons,
    points: menutestHeatmap.points
  }
}

export const hasOverlayData = ({ menuViewMode, heatmap, sections }) =>
  MENU_VIEW_MODES.PLAIN === menuViewMode ? 0 < (sections || []).length : Boolean(heatmap)
